import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { GameState } from '../types/game';
import Instructions from './Instructions';
import { getLevelInfo } from '../utils/gameLogic';

interface GameUIProps {
  gameState: GameState;
  onSubmitWord: () => void;
  onClearSelection: () => void;
  onRequestNewGame: () => void;
  onNextLevel: () => void;
  onShowLeaderboard?: () => void;
}

const GameUI: React.FC<GameUIProps> = ({
  gameState,
  onSubmitWord,
  onClearSelection,
  onRequestNewGame,
  onNextLevel,
  onShowLeaderboard,
}) => {
  const { score, foundWords, currentWord, selectedPath, feedbackMessage, level } = gameState;
  const [showInstructions, setShowInstructions] = useState(false);
  
  const levelInfo = getLevelInfo(level);

  return (
    <div className="game-ui">
      <div className="game-header">
        <div className="title-row">
          <img src="/letterweave-icon.svg" alt="Letterweave" className="app-logo" />
          <motion.h1 
            className="game-title"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Letterweave
          </motion.h1>
        </div>
        
        <div className="score-display">
          <motion.div 
            className="level"
            key={level}
            initial={{ scale: 1.2 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            Level {level}: {levelInfo.name}
          </motion.div>
          <motion.div 
            className="score"
            key={score}
            initial={{ scale: 1.2 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            Score: {score}
          </motion.div>
        </div>
        
        <motion.button
          className="new-game-button"
          onClick={onRequestNewGame}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          New Game
        </motion.button>

        <motion.button
          className="help-button"
          onClick={() => setShowInstructions(true)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          ❓ How to Play
        </motion.button>

        {onShowLeaderboard && (
          <motion.button
            className="leaderboard-button"
            onClick={onShowLeaderboard}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            🏆 Leaderboard
          </motion.button>
        )}
      </div>

      {/*<div className="current-word-section">
        <motion.div 
          className="current-word"
          animate={{ 
            scale: currentWord ? 1.1 : 1,
            color: currentWord ? '#4CAF50' : '#666'
          }}
          transition={{ duration: 0.2 }}
        >
          {currentWord || 'Select letters to form a word...'}
        </motion.div>
        
        <div className="message-area">
          {selectedPath.length > 0 && !feedbackMessage && (
            <div className="selection-hint">
              💡 Click on highlighted letters to continue your word
            </div>
          )}
          {feedbackMessage && (() => {
            const isSuccess = feedbackMessage.startsWith('Great!') || feedbackMessage.startsWith('Level Complete!');
            const isHintMsg = feedbackMessage.startsWith('Hint:');
            const messageClass = `feedback-message ${isHintMsg ? 'hint' : isSuccess ? 'success' : 'error'}`;
            return (
              <motion.div 
                className={messageClass}
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2 }}
              >
                {feedbackMessage}
              </motion.div>
            );
          })()}
        </div>
      </div>*/}


      {/* Removed in-game completion banner - using modal instead */}

      <div className="found-words">
        <h3>Words Found ({foundWords.length})</h3>
        <div className="words-list">
          {foundWords.map((word, index) => (
            <motion.span
              key={index}
              className="found-word"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              {word}
            </motion.span>
          ))}
        </div>
      </div>

      {/* New Game button moved to header */}
      
      <Instructions 
        isOpen={showInstructions} 
        onClose={() => setShowInstructions(false)} 
      />
    </div>
  );
};

export default GameUI;
